import { isNumber } from './isDefined';

export default function calculatePercentage(number, total) {
  if (!isNumber(total) || total === 0 || !isNumber(number)) {
    return '';
  }

  return Number(((number * 100) / total).toFixed(2));
}
